import { Button } from "@/components/ui/button";
import { DrawerFooter } from "@/components/ui/drawer";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import type { Team } from "@/types/team";
import { Loader2 } from "lucide-react";

interface TeamFormProps {
  team: Team;
  setTeam: (team: Team) => void;
  onSave: () => void;
  onCancel: () => void;
  isCreate?: boolean;
  isLoading?: boolean;
}

export default function TeamForm({
  team,
  setTeam,
  onSave,
  onCancel,
  isCreate = false,
  isLoading = false,
}: TeamFormProps) {
  return (
    <>
      <div className="grid gap-6 py-4">
        <div className="grid items-center gap-4">
          <Label htmlFor="name">Nome da Equipe</Label>
          <Input
            id="name"
            value={team.name}
            onChange={(e) =>
              setTeam({
                ...team,
                name: e.target.value,
              })
            }
          />
        </div>

        <div className="grid items-center gap-4">
          <Label htmlFor="description">Descrição (opcional)</Label>
          <Textarea
            id="description"
            value={team.description || ""}
            onChange={(e) =>
              setTeam({
                ...team,
                description: e.target.value,
              })
            }
            placeholder="Descreva a função desta equipe"
            className="resize-none"
            rows={3}
          />
        </div>

        <div className="flex items-center justify-between">
          <Label htmlFor="active" className="cursor-pointer">
            Equipe Ativa
          </Label>
          <Switch
            id="active"
            checked={team.isActive !== false}
            onCheckedChange={(checked) =>
              setTeam({
                ...team,
                isActive: checked,
              })
            }
          />
        </div>
      </div>

      <DrawerFooter>
        <Button onClick={onSave} disabled={isLoading}>
          {isLoading ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              {isCreate ? "Criando..." : "Salvando..."}
            </>
          ) : isCreate ? (
            "Criar Equipe"
          ) : (
            "Salvar"
          )}
        </Button>
        <Button variant="outline" onClick={onCancel} disabled={isLoading}>
          Cancelar
        </Button>
      </DrawerFooter>
    </>
  );
}
